export default __webpack_public_path__ + "static/media/Central Government GPDP Guidelines 3 October 2018.b32a3318.pdf";